import { supabase } from '../lib/supabase'
import type { Database } from '../lib/supabase'

type Subcontractor = Database['public']['Tables']['subcontractors']['Row']
type SubcontractorInsert = Database['public']['Tables']['subcontractors']['Insert']
type SubcontractorUpdate = Database['public']['Tables']['subcontractors']['Update']

export const subcontractorsService = {
  // Hämta alla trädgårdsmästare
  async getAll(): Promise<Subcontractor[]> {
    const { data, error } = await supabase
      .from('subcontractors')
      .select('*')
      .order('name')
    
    if (error) {
      console.error('Error fetching subcontractors:', error)
      throw error
    }
    
    return data || []
  },

  // Hämta trädgårdsmästare efter ID
  async getById(id: string): Promise<Subcontractor | null> {
    const { data, error } = await supabase
      .from('subcontractors')
      .select('*')
      .eq('id', id)
      .single()
    
    if (error) {
      console.error('Error fetching subcontractor:', error)
      throw error
    }
    
    return data
  },

  // Skapa ny trädgårdsmästare
  async create(subcontractor: SubcontractorInsert): Promise<Subcontractor> {
    const { data, error } = await supabase
      .from('subcontractors')
      .insert([subcontractor])
      .select()
      .single()
    
    if (error) {
      console.error('Error creating subcontractor:', error)
      throw error
    }
    
    return data
  },

  // Uppdatera trädgårdsmästare
  async update(id: string, updates: SubcontractorUpdate): Promise<Subcontractor> {
    const { data, error } = await supabase
      .from('subcontractors')
      .update({ ...updates, updated_at: new Date().toISOString() })
      .eq('id', id)
      .select()
      .single()
    
    if (error) {
      console.error('Error updating subcontractor:', error)
      throw error
    }
    
    return data
  },

  // Ta bort trädgårdsmästare
  async delete(id: string): Promise<void> {
    const { error } = await supabase
      .from('subcontractors')
      .delete()
      .eq('id', id)
    
    if (error) {
      console.error('Error deleting subcontractor:', error)
      throw error
    }
  }
}

